export const ALIGNMENTS = {
  light: {
    name: 'Light',
    color: '#F1C40F',
    icon: '☀',
    archetypes: ['industry', 'science', 'faith'],
  },
  dark: {
    name: 'Dark',
    color: '#9B59B6',
    icon: '☾',
    archetypes: ['chaos', 'arcane', 'nature'],
  },
} as const;

export type Alignment = keyof typeof ALIGNMENTS;

interface Props {
  selected: Alignment | null;
  onSelect: (alignment: Alignment) => void;
  disabled?: boolean;
}

export function AlignmentPicker({ selected, onSelect, disabled }: Props) {
  return (
    <div className="flex gap-3">
      {(Object.keys(ALIGNMENTS) as Alignment[]).map((key) => {
        const alignment = ALIGNMENTS[key];
        const isSelected = selected === key;
        return (
          <button
            key={key}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(key)}
            className={`flex flex-col items-center rounded-lg p-3 transition-all ${
              disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:scale-105'
            } ${isSelected ? 'border-2' : 'border border-gray-600'}`}
            style={{
              borderColor: isSelected ? alignment.color : undefined,
              backgroundColor: isSelected ? `${alignment.color}20` : undefined,
            }}
          >
            <span className="text-2xl" style={{ color: alignment.color }}>
              {alignment.icon}
            </span>
            <span className="mt-1 text-sm font-bold" style={{ color: alignment.color }}>
              {alignment.name}
            </span>
            <span className="mt-1 text-xs text-gray-400">{alignment.archetypes.join(', ')}</span>
          </button>
        );
      })}
    </div>
  );
}
